export const ListIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1853 24.5C18.8127 24.5 24.1853 19.1274 24.1853 12.5C24.1853 5.87258 18.8127 0.5 12.1853 0.5C5.55789 0.5 0.185303 5.87258 0.185303 12.5C0.185303 19.1274 5.55789 24.5 12.1853 24.5ZM10.6759 17.8066L18.5665 8.66485C18.7332 8.4363 18.7332 8.09349 18.5109 7.86495L17.8441 7.17932C17.6218 6.95077 17.2884 6.95077 17.0662 7.12218L9.95352 13.35L7.00844 11.8645C6.78617 11.7502 6.50833 11.8073 6.34163 12.0359L5.78596 12.7215C5.61925 12.95 5.67482 13.2357 5.84152 13.4643L9.84238 17.8066C10.0647 18.0923 10.4536 18.0351 10.6759 17.8066Z"
        fill="#5A42ED"
      />
    </svg>
  );
};
